var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "36px",
    viewBox: "0 0 33 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05E2\\u05DE\\u05D5\\u05D3-\\u05DC\\u05E7\\u05D7\\u05D9\\u05DD----\\u05DE\\u05DE\\u05EA\\u05D9\\u05DF-\\u05DC\\u05D0\\u05D9\\u05E9\\u05D5\\u05E8-tooltip",
    transform: "translate(-182.000000, -125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(47.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(96.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(55.500000, 18.000000) scale(-1, 1) translate(-55.500000, -18.000000) translate(39.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 33,
    height: 36
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#0077C6",
    strokeWidth: 1.39729032,
    strokeLinecap: "round",
    transform: "translate(15.574663, 18.182170) rotate(-270.000000) translate(-15.574663, -18.182170) ",
    points: "7.22973875 14.3574137 15.5746627 22.0069273 23.9195866 14.3574137"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow_1.374645c5b1338649648ad780635bcfbc.svg";
export { ForwardRef as ReactComponent };